import _ from 'lodash';

import { compareNatural } from '@zapier/services/esm/utils';

import { measure } from '../PerformanceUtils';

import { Service } from '@zapier/services/esm/types';

const resolver = (services: Service[]) => {
  return _.join(_.map(services, 'name'));
};

export const sortByPopularityRank = measure(
  'sortByPopularityRank',
  _.memoize((services: Array<Service>): Array<Service> => {
    // Note that each block has an early return for performance
    // optimizations. Without this, sorting is roughly 10x slower.
    return services.sort((serviceA, serviceB) => {
      const popularityA = serviceA.popularity || 9999;
      const popularityB = serviceB.popularity || 9999;

      const comparePopularity = popularityA - popularityB;
      if (comparePopularity) {
        return comparePopularity;
      }

      const compareName = compareNatural(
        _.toString(serviceA.name),
        _.toString(serviceB.name)
      );

      return compareName;
    });
  }, resolver)
);

export default sortByPopularityRank;
